import React, { useEffect, useState } from "react";
import { Row, Col, Card, Popover } from "antd";
import "./StatisticsCards.css";
import { GetAppsOverallDataRequest } from "../proto/brevis_explorer/statistics_pb";
import { getAppsOverallData } from "../store/grpc_client";

interface AppData {
  last24hAppRequests: number;
  last24hProofs: number;
  last24hUniqAddress: number;
  totalAppRequests: number;
  totalProofs: number;
  totalUniqAddress: number;
  totalDistributedIncentives: number;
  totaltvl: number;
  totaltradingvolume: number;
}

const StatisticsCards: React.FC = () => {
  let app_request_content =
    "This is the number of requests sent by Brevis-powered dApps. Each request may involve multiple ZK proofs (e.g., an app request may involve multiple storage slots, receipts or transactions).";
  let unique_address_content =
    "This is the number of unique user addresses attested in Brevis-powered dApp requests.";
  let distributed_incentives_content =
    "This is the total incentives distributed via Brevis-powered ZK solutions (e.g., Usual, Incentra, OpenEden, Linea Ignition, etc.).";
  let total_tvl_content =
    "This is the total TVL growth secured by Brevis ZK proofs in all the Brevis-powered apps.";

  let total_trading_volume_content =
    "This is the cumulative trading volume in all the DEX pools with Brevis-powered hooks.";

  const [appsData, setAppsData] = useState<AppData>();

  useEffect(() => {
    let req = new GetAppsOverallDataRequest();
    getAppsOverallData(req).then((res) => {
      console.log("getAppsOverallData res:", res.toObject());
      if (res) {
        const {
          totalProofs,
          totalAppRequests,
          totalUniqAddress,
          last24hProofs,
          last24hAppRequests,
          last24hUniqAddress,
          totalDistributedIncentives,
          totaltvl,
          totaltradingvolume,
        } = res.toObject();
        let data: AppData = {
          last24hAppRequests,
          last24hProofs,
          last24hUniqAddress,
          totalAppRequests,
          totalProofs,
          totalUniqAddress,
          totalDistributedIncentives,
          totaltvl,
          totaltradingvolume,
        };
        setAppsData(data);
      }
    });
  }, []);
  return (
    <div className="statistics-section">
      <Row gutter={[20, 12]}>
        <Col xs={24} sm={12} md={8}>
          <Card className="stat-card stat-card1">
            <div className="stat_number">
              {appsData?.totalProofs.toLocaleString()}
            </div>
            <div className="stat_des">
              Number of Proofs Generated (all time)
            </div>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card className="stat-card stat-card2">
            <div className="stat_number">
              {appsData?.totalAppRequests.toLocaleString()}
            </div>
            <div className="stat_des">
              <span>Number of App Requests (all time)</span>
              <Popover
                placement="top"
                content={app_request_content}
                color="#22252E"
                rootClassName="stat_popover"
              >
                <img src="/info.svg" alt="Brevis" width="20" />
              </Popover>
            </div>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card className="stat-card stat-card3">
            <div className="stat_number">
              {appsData?.totalUniqAddress.toLocaleString()}
            </div>
            <div className="stat_des">
              <span>Unique Addresses (all time)</span>
              <Popover
                placement="top"
                content={unique_address_content}
                color="#22252E"
                rootClassName="stat_popover"
              >
                <img src="/info.svg" alt="Brevis" width="20" />
              </Popover>
            </div>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card className="stat-card stat-card4">
            <div className="stat_number">
              {appsData?.last24hProofs.toLocaleString()}
            </div>
            <div className="stat_des">Number of Proofs Generated (24h)</div>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card className="stat-card stat-card5">
            <div className="stat_number">
              {appsData?.last24hAppRequests.toLocaleString()}
            </div>
            <div className="stat_des">Number of App Requests (24h)</div>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card className="stat-card stat-card6">
            <div className="stat_number">
              {appsData?.last24hUniqAddress.toLocaleString()}
            </div>
            <div className="stat_des">Unique Addresses (24h)</div>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card className="stat-card stat-card7">
            <div className="stat_number">
              $
              {Math.floor(
                appsData?.totalDistributedIncentives || 0
              ).toLocaleString()}
            </div>
            <div className="stat_des">
              <span>
                Total Distributed Incentives (via Bevis-powered solutions)
              </span>
              <Popover
                placement="top"
                content={distributed_incentives_content}
                color="#22252E"
                rootClassName="stat_popover"
              >
                <img src="/info.svg" alt="Brevis" width="20" />
              </Popover>
            </div>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card className="stat-card stat-card8">
            <div className="stat_number">
              ${Math.floor(appsData?.totaltvl || 0).toLocaleString()}
            </div>
            <div className="stat_des">
              <span>Total TVL (secured by Brevis ZKP)</span>
              <Popover
                placement="top"
                content={total_tvl_content}
                color="#22252E"
                rootClassName="stat_popover"
              >
                <img src="/info.svg" alt="Brevis" width="20" />
              </Popover>
            </div>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card className="stat-card stat-card9">
            <div className="stat_number">
              ${Math.floor(appsData?.totaltradingvolume || 0).toLocaleString()}
            </div>
            <div className="stat_des">
              <span>Total Trading Volume (with Brevis-powered hooks)</span>
              <Popover
                placement="top"
                content={total_trading_volume_content}
                color="#22252E"
                rootClassName="stat_popover"
              >
                <img src="/info.svg" alt="Brevis" width="20" />
              </Popover>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default StatisticsCards;
